export const DISPATCHER_URL =
    'https://roadlords.com/dispatcher?utm_source=rl_drive&utm_medium=microsite&utm_campaign=dispatcher_teasing&utm_id=rl_drive01';

export const SMALL_DEVICE_WIDTH = 992;
